import mixins from '@synergycms_core/less/mixins.js';
export default {
  confirmationPageWrapper: {
    minHeight: '100vh',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  newCofContainer: {
    background: '#fff',
    textAlign: 'center',
    padding: '20px',
    flex: '1 0 auto',
    '@media(min-width:801px)': {
      padding: '20px 30px'
    }
  },
  mainTitle: {
    font: (data) => '500 16px ' + data.fontFamily1,
    marginBottom: '20px',
    display: 'block',
    '@media(min-width:801px)': {
      fontSize: '18px',
      margin: '0 10px 10px'
    }
  },
  reservationInfo: {
    marginLeft: '10px',
    fontWeight: '500'
  },
  newCofId: {
    marginTop: '30px'
  },
  hide: {
    display: 'none'
  },
  paddedText: {
    padding: '0 0 20px',
    display: 'block',
    font: (data) => '300 13px ' + data.fontFamily1
  },
  creditCard: {
    font: (data) => '400 18px ' + data.fontFamily1,
    color: '#8d8d8d',
    paddingTop: '25px'
  },
  goldInfo: {
    fontSize: '13px',
    textAlign: 'left'
  },
  defaultStyle: {
    background: '#fff'
  },
  pendingContainer: {
    minHeight: 'calc(100vh - 29px)',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    '@media(min-width:901px)': {
      margin: '0 auto',
      padding: '20px 10px 40px',
      overflow: 'hidden',
      maxWidth: '1190px',
      minHeight: '100vh',
      boxSizing: 'border-box',
      justifyContent: 'space-between'
    },
    '&:lang(ar)': {
      direction: 'rtl'
    }
  },
  resumeSimpleContainer: {
    padding: '0 20px 25px',
    '@media (min-width: 801px), print': {
      padding: '0 0 20px'
    }
  },
  countryContainer: {
    padding: '0 20px',
    display: 'flex',
    width: '100%',
    boxSizing: 'border-box',
    '& > div': {
      height: '50px',
      minWidth: '130px',
      '& > div': {
        height: '40px!important'
      }
    },
    '@media (min-width: 541px)': {
      paddingRight: '29px'
    },
    '@media (min-width: 901px)': {
      padding: '0 20px 0 15px'
    }
  },
  locationContainer: {
    padding: '0 20px',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '16px',
    width: '100%',
    boxSizing: 'border-box',
    '& > label': {
      width: '100%'
    },
    '& > div': {
      height: '50px',
      minWidth: '130px',
      '& > div': {
        height: '40px!important'
      }
    },
    '@media (min-width: 541px)': {
      paddingRight: '29px'
    },
    '@media (min-width: 901px)': {
      padding: '0 20px 0 15px'
    }
  },
  cityContainer: {
    height: '50px',
    boxShadow: '0 0 2px 0 rgba(0,0,0,50%);',
    flex: '1',
    '& span': {
      display: 'none'
    },
    '& svg': {
      fill: (data) => data.mainColor
    }
  },
  citySelector: {
    height: '50px',
    '& > div': {
      border: 'none',
      '& > div': {
        '& > div': {
          font: '300 13px Roboto, sans-serif',
          color: '#000'
        }
      }
    }
  },
  resumeSimple: {
    '@media (min-width: 801px), print': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0 20px 10px 15px'
    }
  },
  resumeInformation: {
    font: (data) => '300 16px ' + data.fontFamily1,
    '@media (min-width: 801px), print': {
      padding: '0 15px'
    }
  },
  title: {
    color: (data) => data.mainColor,
    font: (data) => '24px/1.13 ' + data.fontFamily1,
    maxWidth: '250px',
    margin: '0 auto',
    textAlign: 'center',
    '@media (min-width: 801px), print': {
      position: 'relative',
      paddingRight: '20px',
      minHeight: '60px',
      maxWidth: 'none',
      margin: '0',
      display: 'flex',
      alignItems: 'center',
      textAlign: 'left'
    }
  },
  locatorBox: {
    border: '1px dashed #9e9e9e',
    width: '150px',
    margin: '20px auto',
    padding: '10px 6px 8px',
    textAlign: 'left',
    '@media (min-width: 801px), print': {
      padding: '8px 12px',
      margin: 0
    }
  },
  locatorTitle: {
    fontSize: '11px',
    color: '#9b9b9b',
    display: 'block',
    '@media (min-width: 801px), print': {
      fontSize: '11px'
    }
  },
  locatorValue: {
    fontSize: '18px',
    fontWeight: 'bold',
    wordBreak: 'break-word'
  },
  finalPrice: {
    font: (data) => '11px ' + data.fontFamily1,
    padding: '15px 20px',
    width: '100%',
    boxSizing: 'border-box',
    '@media (min-width: 901px)': {
      padding: '20px'
    }
  },
  priceContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
    padding: '15px 20px 20px',
    '@media (min-width: 901px)': {
      flex: 1,
      padding: '0'
    }
  },
  buttonContainer: {
    paddingTop: '15px',
    display: 'table-caption',
    '& > button': {
      width: '100%',
      position: 'relative',
      padding: '0 20px',
      textTransform: 'uppercase',
      letterSpacing: '.5px',
      font: (data) => 'normal 18px/1.13 ' + data.fontFamily1,
      '@media (min-width: 901px)': {
        maxWidth: '255px',
        height: '50px'
      }
    },
    '@media (min-width: 901px)': {
      display: 'table-cell',
      padding: '0 0 0 30px',
      width: '215px',
      verticalAlign: 'middle'
    }
  },
  noPaddingButton: {
    paddingTop: 0
  },
  payContainer: {
    font: (data) => '300 11px ' + data.fontFamily1,
    background: '#fff',
    textAlign: 'left',
    paddingTop: '20px',
    '@media (min-width: 901px)': {
      width: '64%',
      paddingTop: 0,
      background: 'transparent'
    }
  },
  resumeContainer: {
    display: 'block',
    width: '31%',
    padding: '0 10px',
    background: '#fff'
  },
  bookIcon: {
    width: '50px',
    height: '50px',
    fill: (data) => data.mainColor,
    display: 'block',
    margin: '0 auto',
    paddingBottom: '10px',
    '@media (min-width: 801px)': {
      width: '60px',
      height: '60px',
    },
  },
  bookIconGreen: {
    composes: '$bookIcon',
    fill: '#5ca70a'
  },
  customerForm: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    alignItems: 'flex-start',
    '@media (min-width: 901px)': {
      display: 'block'
    },
    '& $inputBox': {
      position: 'relative',
      cursor: 'pointer',
      display: 'block',
      marginBottom: '15px',
      paddingLeft: '0',
      '&:before': {
        content: 'none'
      },
      '&:nth-child(odd)': {
        '@media (min-width: 901px)': {
          marginRight: '24px',
          '&:lang(ar)': {
            marginLeft: '30px',
            marginRight: '0'
          }
        }
      },
      '& $labelText': {
        position: 'absolute',
        top: '14px',
        left: '15px',
        zIndex: '0',
        color: '#8d8d8d',
        right: '10px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        ...mixins.transition('top 0.3s'),
        '@media (min-width: 901px)': {
          top: '18px',
          fontSize: '13px',
          width: 'fit-content'
        },
        '&:lang(ar)': {
          left: 'auto',
          right: '15px',
          '@media (min-width: 901px), print': {
            float: 'right'
          }
        },
      },
      '& $inputText': {
        font: data => '300 13px ' + data.fontFamily1,
        paddingRight: '40px',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        boxShadow: 'none',
        '&:lang(ar)': {
          direction: 'rtl',
        },
        '&:not([value=""]) ~ $labelText': {
          top: '6px'
        },
        '&:focus':{
          '& ~ $labelText': {
            top: '6px'
          }
        },
        '@media (min-width: 901px)': {
          height: '50px',
          fontSize: '16px',
          boxShadow: '0 0 2px -1px rgb(0,0,0,0.5)'
        },
        '&.travelclub_card':{
          '@media (min-width: 901px)': {
            fontSize: '15px',
          }
        },
      },
      '@media (min-width: 901px)': {
        width: "calc(50% - 15px)",
        float: 'left',
        '&:lang(ar)':{
          float: 'right',
        }
      },
    },
  },
  wrapperPciFrame: {
    width: '100%',
    boxSizing: 'border-box'
  },
  payComponent: {
    width: '100%',
    padding: '0 5px',
    boxSizing: 'border-box'
  },
  confirmationContainer: {
    font: (data) => '300 13px ' + data.fontFamily1,
    padding: '40px 28px 20px',
    flex: '1 0 auto',
    '@media (min-width: 801px), print': {
      margin: '0 auto',
      padding: '40px 0',
      font: (data) => '300 13px ' + data.fontFamily1,
      background: '#ffffff',
      textAlign: 'center',
      maxWidth: '1190px',
      width: '100%',
    }
  },
  confirmationContent: {
    paddingBottom: '12px',
    '@media (min-width: 801px), print': {
      paddingBottom: '30px',
      display: 'table',
      maxWidth: '1000px',
      width: '100%',
    }
  },
  customer: {
    '@media (min-width: 801px), print': {
      display: 'table-cell',
      textAlign: 'left',
      verticalAlign: 'bottom',
      padding: '23px 0 0 15px'
    },
    '&:lang(ar)': {
      '@media (min-width: 801px)': {
        paddingLeft: 0,
        paddingRight: '20px',
        textAlign: 'right'
      }
    }
  },
  titleConfirmation: {
    marginBottom: '13px',
    color: '#666666',
    font: (data) => '300 16px ' + data.fontFamily1,
    letterSpacing: '.03em',
    '& > div': {
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      gap: '14px',
      '@media (min-width: 801px), print': {
        textAlign: 'left',
        gap: '12px',
      },
      '&:lang(ar)': {
        '@media (min-width: 801px)': {
          textAlign: 'right'
        }
      }
    },
    '@media (min-width: 801px), print': {
      display: 'block',
      position: 'relative',
      minHeight: '60px',
      fontSize: '20px',
    }
  },
  bodyConfirmation: {
    textAlign: 'center',
    '@media (min-width: 801px), print': {
      boxSizing: 'content-box',
      marginRight: '100px',
      border: '0',
      color: 'inherit',
      padding: '0',
      textAlign: 'left'
    },
    '&:lang(ar)': {
      '@media (min-width: 801px)': {
        textAlign: 'right',
        marginLeft: '100px',
        marginRight: 0
      }
    }
  },
  email: {
    padding: '0',
    textDecoration: 'none',
    margin: '0 0 0 3px',
    color: '#000',
    fontWeight: '500',
    border: '0',
    '&:lang(ar)': {
      marginRight: '3px',
      marginLeft: 0
    }
  },
  simpleBookingInfo: {
    '@media (min-width: 801px), print': {
      display: 'table-cell',
      paddingTop: '20px',
      paddingRight: '20px',
      width: '350px'
    },
    '&:lang(ar)': {
      '@media (min-width: 801px)': {
        paddingRight: 0,
        paddingLeft: '20px'
      }
    }
  },
  locatorBoxConfirmation: {
    composes: '$locatorBox',
    marginLeft: 'auto'
  },
  bookIconConfirmation: {
    composes: '$bookIcon',
    fill: '#5ca70a'
  },
  tableContainer: {
    display: 'table',
    width: '100%',
    captionSide: 'bottom',
    '& > span': {
      display: 'block',
      textAlign: 'right',
      fontSize: '14px',
      color: '#333'
    },
    '@media (min-width: 901px)': {
      textAlign: 'right'
    }
  },
  tableCell: {
    display: 'table-cell',
    verticalAlign: 'bottom',
    '@media (min-width: 901px)': {
      textAlign: 'left'
    },
    '&:first-of-type': {
      '& > span:first-of-type': {
        paddingBottom: '5px'
      }
    },
    '&:nth-of-type(2)': {
      textAlign: 'right',
      '&:lang(ar)': {
        textAlign: 'left'
      }
    }
  },
  subtitleConfirmationBox: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '6px',
    '@media(min-width:801px)': {
      marginTop: '20px',
      justifyContent: 'flex-start',
    }
  },
  subtitleConfirmation: {
    fontWeight: 'bold',
    fontSize: '22px',
    letterSpacing: '.03em',
    color: data => data.mainColor,
    '@media(min-width:801px)': {
      fontSize: '25px',
    }
  },
  subtitleDescConfirmation: {
    fontWeight: '300',
    fontSize: '12px',
    '@media(min-width:801px)': {
      fontSize: '14px',
      lineHeight: '25px',
    }
  },
  inputBox:{},
  labelText:{},
  inputText:{},
  selectCountry:{},
  personalData:{
    width: '100%',
    padding: '15px 20px',
    boxSizing: 'border-box',
    display: 'flow-root',
  }
};
